/**
 * Detects if application is currently running in a local development location,
 * such as localhost, 127.0.0.1, cloudbeds-local, cloudbeds-stage, or a local html file.
 *
 * Only works if window.location is available (i.e. in a browser environment),
 * otherwise it defaults to false.
 *
 * @returns {boolean} true if local development URL detected, false if not.
 */
export const detectDevUrl = (): boolean => {
  if (typeof window === 'undefined' || !window?.location) return false;

  // Check for files run off the local disk.
  if (window.location.protocol === 'file:') return true;

  const baseURL = window.location.hostname;

  return !!(
    baseURL?.match(/^((localhost)|(127.0.0.1))(:[0-9]+)?$/g) ||
    baseURL?.match(
      /^([a-zA-Z0-9\\-]+\.)?[a-zA-Z0-9\\-]+\.cloudbeds-(local|stage)\.com(:[0-9]+)?$/g,
    )
  );
};
